import { useState, useRef } from "react";
// css
import "./yachtDetail.css";
import "./responsive.css";
// other assets
import ShareImg from "assets/Images/icons/share.png";
import ViewOfferImg from "assets/Images/icons/viewoffer-arrow.png";
import { ChevronRight, ChevronLeft, Close } from "@material-ui/icons";
import FavIcon from "Utills/FavIcon";
import sliderImg from "assets/Images/yachtDetailSlider/sliderImg.png";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Pagination, Navigation, Autoplay, Thumbs } from "swiper";
// calendars
import { Calendar, DateRangePicker } from "react-date-range";
//
import { CustomRatings } from "Utills/CustomRatings";
import { Link, useParams } from "react-router-dom";
import Moment from "moment";
//
import LocationIcon from "assets/Images/icons/LocationIcon.png";
import yachtIcon from "assets/Images/yachtDetailSlider/features_icons/plan.png";
import plan from "assets/Images/yachtDetailSlider/features_icons/yacht.png";
import guestsIcon from "assets/Images/yachtDetailSlider/features_icons/guests.png";
import cabinsIcon from "assets/Images/yachtDetailSlider/features_icons/cabins.png";
import bedsIcon from "assets/Images/yachtDetailSlider/features_icons/beds.png";
import lengthIcon from "assets/Images/yachtDetailSlider/features_icons/length.png";
import draftIcon from "assets/Images/yachtDetailSlider/features_icons/draft.png";
import engineIcon from "assets/Images/yachtDetailSlider/features_icons/engine.png";
import fuelIcon from "assets/Images/yachtDetailSlider/features_icons/fuel.png";
import yachtOwnerProfile from "assets/Images/yachtDetailSlider/features_icons/yachtOwner.png";
import calendarIcon from "assets/Images/yachtDetailSlider/features_icons/calendar.png";
import inboxIcon from "assets/Images/yachtDetailSlider/features_icons/inbox.png";
import langIcon from "assets/Images/yachtDetailSlider/features_icons/lang.png";
import responseIcon from "assets/Images/yachtDetailSlider/features_icons/response.png";
import StarImg from "assets/Images/icons/Starwhite.png";
import defaultPersonImg from "assets/Images/icons/defaultPerson.png";
import StarImgBlue from "assets/Images/icons/Star.png";
import reviewUSerFlag from "assets/Images/icons/flag.png";
import defaultCardImg from "assets/Images/icons/defaultCardImg.png";
import SliderCard from "Components/sliderCard/SliderCard";
import CustomModal from "Utills/Model/CustomModel";
import SiginInPopup from "Components/Popup/SiginInPopup/SiginInPopup";
import { connect } from "react-redux";
import logo from "assets/Images/icons/newLogo1.png";
import { Helmet } from "react-helmet";

// Swiper Slider config
SwiperCore.use([Pagination, Navigation, Autoplay, Thumbs]);

// ================== This is a yacht Detail page  =======================
// ================== Every Data is static here images etc ================================

const YachtDetail = (props) => {
  const { id } = useParams();
  // =========== For login modal ====================
  const [loginOpen, setLogin] = useState(false);
  //
  const [galleryModal, setGalleryModal] = useState(false);
  // ================= favourite yacht ==============
  const [favYacht, SetFavYacht] = useState(false);
  const [formData] = useState({
    avail_days: new Date(),
  });
  const [calendarPreview, setCalendarPreview] = useState(0);

  // ============ Static Images array for yacht detail page ==========================
  // Static
  const images = [
    sliderImg,
    sliderImg,
    sliderImg,
    sliderImg,
    sliderImg,
    sliderImg,
    sliderImg,
    sliderImg,
    sliderImg,
    sliderImg,
    sliderImg,
    sliderImg,
  ];

  // ================ Just for showing up coming days  ========================
  const getFutureDays = (howManyDays) => {
    let nowDate = new Date();
    let currentYear = nowDate.getFullYear();
    let currentMonth = nowDate.getMonth();
    let currentDate = nowDate.getDate();
    return new Date(
      `${currentMonth} , ${currentDate + howManyDays} ,${currentYear}   `
    );
  };
  //================ Slider Navigation reference    ====================
  const navigationPrevRef = useRef(null);
  const navigationNextRef = useRef(null);

  //================== Calender date state  ==================
  const [dateState] = useState([
    {
      startDate: new Date(),
      endDate: getFutureDays(12),
      key: "selection",
    },
  ]);

  // =================== characteristic data =====================
  // Static
  let characteristicData = [
    {
      icon: (
        <svg width="37" height="32" viewBox="0 0 37 32" fill="none">
          <path
            d="M21.5412 1.85158C21.5412 0.830481 20.7105 -0.000244141 19.6894 -0.000244141H16.9261C15.905 -0.000244141 15.0743 0.830481 15.0743 1.85158V4.62016H21.5412V1.85158Z"
            fill="#1A4D6D"
          />
          <path
            d="M18.5792 11.585L29.3133 14.3897V7.46781C29.3133 7.08048 28.9982 6.76538 28.6109 6.76538H8.0052C7.61787 6.76538 7.30277 7.08048 7.30277 7.46781V14.3897L18.0369 11.585C18.2146 11.5386 18.4014 11.5386 18.5792 11.585Z"
            fill="#1A4D6D"
          />
          <path
            d="M35.5432 29.8545C34.3592 29.8545 33.8251 29.5885 33.1489 29.2517C32.8314 29.0937 32.4967 28.927 32.0972 28.785C31.5426 28.5878 30.8629 28.4383 29.9315 28.4252L33.8592 18.538C33.9461 18.3032 33.8766 18.1077 33.8271 18.0117C33.7771 17.9149 33.6568 17.7429 33.4113 17.6787L18.3079 13.7324L3.20461 17.6787C2.95903 17.7429 2.83867 17.9149 2.78882 18.0117C2.73926 18.1078 2.66968 18.3035 2.75685 18.5383L6.67569 28.4254C5.7447 28.4394 5.06573 28.5898 4.51149 28.7877C4.11536 28.9291 3.78274 29.0947 3.46729 29.2518C2.79097 29.5885 2.25682 29.8545 1.07273 29.8545C0.480298 29.8545 0 30.3348 0 30.9273C0 31.5197 0.480298 32 1.07273 32C2.76136 32 3.64443 31.5603 4.42352 31.1724C4.72711 31.0213 5.00237 30.8847 5.32026 30.7797C5.71066 30.6508 6.16543 30.5698 6.81808 30.5698C6.96704 30.5698 7.10564 30.574 7.23566 30.5821C8.13875 30.6378 8.62141 30.8781 9.21263 31.1725C9.99172 31.5604 10.8748 32.0001 12.5634 32.0001C14.252 32.0001 15.135 31.5604 15.9141 31.1725C16.5904 30.8358 17.1245 30.5698 18.3085 30.5698C19.4924 30.5698 20.0265 30.8357 20.7027 31.1725C21.4818 31.5604 22.3648 32.0001 24.0534 32.0001C25.7419 32.0001 26.625 31.5604 27.404 31.1725C27.9971 30.8772 28.4811 30.6364 29.3896 30.5816C29.517 30.5739 29.6527 30.5698 29.7984 30.5698C30.4439 30.5698 30.8957 30.6492 31.2832 30.7757C31.6064 30.8812 31.8851 31.0194 32.1926 31.1725C32.9717 31.5604 33.8547 32.0001 35.5433 32.0001C36.1357 32.0001 36.616 31.5198 36.616 30.9273C36.616 30.3349 36.1356 29.8545 35.5432 29.8545ZM8.39035 19.2222L18.0367 16.7017C18.2145 16.6553 18.4013 16.6553 18.5791 16.7017L28.2255 19.2222C28.7987 19.372 29.1419 19.9581 28.9922 20.5313C28.8662 21.0136 28.4312 21.3332 27.9551 21.3332C27.8653 21.3332 27.7741 21.3218 27.6832 21.298L18.3079 18.8484L8.93272 21.298C8.35952 21.4478 7.77338 21.1045 7.62363 20.5313C7.47388 19.9581 7.81715 19.372 8.39035 19.2222Z"
            fill="#1A4D6D"
          />
        </svg>
      ),
      title: "Type",
      sec_title: "Motor Yacht",
    },
    { img: guestsIcon, title: "Guests", sec_title: "12" },
    { img: cabinsIcon, title: "Cabins", sec_title: "1" },
    { img: bedsIcon, title: "Beds", sec_title: "2" },
    { img: lengthIcon, title: "Length", sec_title: "8.0km" },
    {
      icon: (
        <svg width="34" height="32" viewBox="0 0 34 32" fill="none">
          <path
            d="M32.5517 30.8963H29.2414V30.3446C29.2414 30.0399 28.9944 29.7929 28.6896 29.7929H27.5862C27.2815 29.7929 27.0345 29.5459 27.0345 29.2411V28.1377C26.2507 28.4627 25.4151 28.6451 24.5672 28.6762C25.024 29.3322 25.2959 30.099 25.3545 30.8963H7.75172C7.80835 30.0986 8.07942 29.3309 8.53627 28.6745C7.68843 28.644 6.85286 28.4622 6.06896 28.1377V29.2411C6.06896 29.5459 5.82195 29.7929 5.51724 29.7929H4.41379C4.10908 29.7929 3.86207 30.0399 3.86207 30.3446V30.8963H0.551724C0.247015 30.8963 0 31.1433 0 31.448C0 31.7527 0.247015 31.9998 0.551724 31.9998H32.5517C32.8564 31.9998 33.1034 31.7527 33.1034 31.448C33.1034 31.1433 32.8564 30.8963 32.5517 30.8963Z"
            fill="#1A4D6D"
          />
          <path
            d="M4.96551 2.75863C4.96551 1.8445 5.70655 1.10346 6.62068 1.10346H9.56689C10.0075 1.10246 10.4301 1.27791 10.7404 1.59063L11.536 2.38677C11.8517 2.16006 12.1999 1.98242 12.5688 1.85987L11.5205 0.808838C11.0034 0.289203 10.3 -0.00203343 9.56689 1.06882e-05H6.62068C5.09789 0.00183475 3.86388 1.23584 3.86206 2.75863V12.6897H4.96551V2.75863Z"
            fill="#1A4D6D"
          />
          <path
            d="M1.65512 15.4481H8.49098C9.94757 15.4487 11.3551 15.9747 12.4551 16.9295C13.5509 17.8621 14.8913 18.4606 16.3172 18.6542C16.3433 18.6579 16.3691 18.6635 16.3944 18.6707C16.812 18.73 17.2333 18.7593 17.6551 18.7584L18.2069 18.7585L18.2068 17.9309C18.2086 17.8227 18.1878 17.7154 18.1456 17.6158C18.0178 17.3053 17.715 17.1028 17.3792 17.1033H17.3732C16.2706 17.0909 15.1927 16.7758 14.257 16.1924C13.9798 16.0253 13.7178 15.834 13.4741 15.6208C12.0177 14.4059 10.1721 13.7569 8.2758 13.7929H2.20684C1.59742 13.7929 1.10339 14.287 1.10339 14.8964C1.10339 15.2011 1.35041 15.4481 1.65512 15.4481Z"
            fill="#1A4D6D"
          />
          <path
            d="M21.5172 17.931V24.2758C21.5172 24.5805 21.7642 24.8275 22.0689 24.8275H26.1517C26.4564 24.8275 26.7034 24.5805 26.7034 24.2758V17.931C26.7034 17.1262 26.3837 16.3543 25.8146 15.7853C25.2456 15.2162 24.4737 14.8965 23.6689 14.8965H20.1892C21.0364 15.678 21.518 16.7784 21.5172 17.931Z"
            fill="#1A4D6D"
          />
          <path
            d="M11.894 3.52294C11.5228 3.87691 11.2569 4.32685 11.126 4.8228C11.0815 4.98888 11.1169 5.16622 11.2219 5.30243C11.3268 5.43863 11.4892 5.51813 11.6612 5.51742H15.905C16.0789 5.51713 16.2426 5.43538 16.3473 5.29657C16.452 5.15775 16.4855 4.9779 16.438 4.81066C16.1524 3.7386 15.2547 2.94035 14.1566 2.78197C14.0348 2.7666 13.912 2.75886 13.7892 2.7588C13.1196 2.75698 12.4728 3.00191 11.9724 3.4468C11.9448 3.47052 11.9205 3.49756 11.894 3.52294Z"
            fill="#1A4D6D"
          />
          <path
            d="M27.8069 18.7587H31.4483C31.753 18.7587 32 18.5117 32 18.207C32 17.5975 31.506 17.1035 30.8966 17.1035H27.7225C27.7786 17.3758 27.8069 17.6531 27.8069 17.9311V18.7587Z"
            fill="#1A4D6D"
          />
          <path
            d="M27.8069 19.8621V24.2759C27.8042 25.1889 27.0648 25.9283 26.1518 25.9311H19.8621C18.9491 25.9283 18.2097 25.1889 18.2069 24.2759V19.8621H17.6552C17.153 19.8623 16.6514 19.8254 16.1545 19.7518C16.1269 19.7462 16.0994 19.7407 16.0773 19.7352C14.471 19.4994 12.964 18.8147 11.7297 17.76C10.8305 16.9811 9.68077 16.5521 8.49108 16.5518H2.75867V21.5173C2.7608 24.8682 5.47672 27.5841 8.82763 27.5862H24.2759C27.6268 27.5841 30.3427 24.8682 30.3449 21.5173V19.8621H27.8069ZM8.82763 26.4828C6.08702 26.4785 3.86637 24.2579 3.86211 21.5173C3.86211 21.2126 4.10913 20.9655 4.41384 20.9655C4.71855 20.9655 4.96556 21.2126 4.96556 21.5173C4.968 23.6492 6.69568 25.3769 8.82763 25.3793C9.13234 25.3793 9.37935 25.6264 9.37935 25.9311C9.37935 26.2358 9.13234 26.4828 8.82763 26.4828Z"
            fill="#1A4D6D"
          />
          <path
            d="M15.4583 15.5796C16.0655 15.849 16.7212 15.992 17.3854 16C18.1631 16.0014 18.8635 16.4708 19.1603 17.1896C19.2604 17.4239 19.3115 17.6763 19.3104 17.9311V24.2759C19.3104 24.5806 19.5574 24.8276 19.8621 24.8276H20.5154C20.45 24.6509 20.4157 24.4643 20.4138 24.2759V17.9311C20.4148 16.7582 19.7398 15.6898 18.6802 15.1871C17.6206 14.6843 16.3661 14.8371 15.4583 15.5796Z"
            fill="#1A4D6D"
          />
          <path
            d="M13.2413 8.27585V11.0345C13.2413 11.3392 13.4883 11.5862 13.7931 11.5862C14.0978 11.5862 14.3448 11.3392 14.3448 11.0345V8.27585C14.3448 7.97114 14.0978 7.72412 13.7931 7.72412C13.4883 7.72412 13.2413 7.97114 13.2413 8.27585Z"
            fill="#1A4D6D"
          />
          <path
            d="M11.0737 8.07066L9.97025 10.8293C9.8569 11.1123 9.99449 11.4337 10.2776 11.5471C10.5606 11.6604 10.882 11.5228 10.9954 11.2398L12.0988 8.48114C12.2122 8.19806 12.0746 7.8767 11.7915 7.76334C11.5084 7.64999 11.1871 7.78758 11.0737 8.07066Z"
            fill="#1A4D6D"
          />
          <path
            d="M15.7953 7.76335C15.6593 7.81759 15.5505 7.92366 15.4927 8.05818C15.435 8.1927 15.4331 8.34466 15.4874 8.48059L16.5909 11.2392C16.6642 11.4223 16.8296 11.5524 17.0249 11.5805C17.2201 11.6085 17.4155 11.5303 17.5374 11.3752C17.6594 11.2202 17.6893 11.0118 17.616 10.8287L16.5125 8.07011C16.3991 7.78739 16.078 7.65007 15.7953 7.76335Z"
            fill="#1A4D6D"
          />
        </svg>
      ),

      title: "Bathrooms",
      sec_title: "5",
      // padd: true,
    },
    { img: engineIcon, title: "Cruising Speed", sec_title: "26Kn" },
    { img: fuelIcon, title: "Fuel", sec_title: "980L" },
  ];
  // =================== features data =====================
  // Static
  let featuresData = [
    {
      img: (
        <svg width="28" height="27" viewBox="0 0 28 27" fill="none">
          <path
            d="M5.96329 7.18314L5.31022 4.90723C4.66595 2.66181 5.89187 0.419381 7.89406 0.0513167C9.90432 -0.318215 11.8403 1.35109 12.036 3.67081L12.2351 6.03017C12.3898 7.86309 11.2912 9.46865 9.67978 9.76489C8.06869 10.061 6.4707 8.95158 5.96329 7.18314Z"
            fill="#1A4D6D"
          />
          <path
            d="M16.396 9.76471C14.7846 9.46846 13.686 7.86291 13.8407 6.02998L14.0397 3.67068C14.2362 1.34266 16.1798 -0.316931 18.1817 0.0511888C20.1969 0.42168 21.4062 2.67472 20.7655 4.90716L20.1125 7.18301C19.6052 8.95106 18.0073 10.061 16.396 9.76471Z"
            fill="#1A4D6D"
          />
          <path
            d="M1.86188 12.6029L0.842545 11.6005C-0.291005 10.4858 -0.291401 8.64923 0.90595 7.66518C2.1033 6.68114 3.90506 7.03729 4.77906 8.36529L5.56504 9.55948C6.27526 10.6385 6.0943 12.0411 5.14419 12.822C4.19391 13.6029 2.78286 13.5086 1.86188 12.6029Z"
            fill="#1A4D6D"
          />
          <path
            d="M20.932 12.822C19.9819 12.0411 19.801 10.6385 20.5112 9.55941L21.2971 8.36528C22.1712 7.03723 23.9729 6.68119 25.1703 7.66517C26.3676 8.64928 26.367 10.4859 25.2336 11.6005L24.2143 12.6029C23.2935 13.5083 21.8825 13.6031 20.932 12.822Z"
            fill="#1A4D6D"
          />
          <path
            d="M20.5692 14.4073C18.9214 11.9129 16.1009 10.3574 13.038 10.3574C8.05711 10.3574 4.00439 14.4163 4.00439 19.4057C4.00439 22.3113 6.38859 24.4188 8.98813 24.4188C9.99369 24.4188 10.5936 24.1532 11.7242 23.7599C14.1094 22.9305 15.036 24.5841 17.4397 24.4019C18.5508 25.6237 20.1526 26.3921 21.9305 26.3921C25.2775 26.3921 28 23.6696 28 20.3226C28 16.4276 24.3629 13.5311 20.5692 14.4073ZM21.9305 24.5854C19.5801 24.5854 17.6678 22.6731 17.6678 20.3226C17.6678 17.9722 19.5801 16.0599 21.9305 16.0599C24.2809 16.0599 26.1932 17.9722 26.1932 20.3226C26.1932 22.6731 24.2809 24.5854 21.9305 24.5854Z"
            fill="#1A4D6D"
          />
          <path
            d="M20.6425 22.457L19.5698 21.3842C19.217 21.0314 19.217 20.4595 19.5698 20.1067C19.9226 19.7539 20.4946 19.7539 20.8473 20.1067L21.2813 20.5406L23.1551 18.667C23.5078 18.3141 24.0798 18.3141 24.4326 18.667C24.7854 19.0198 24.7854 19.5917 24.4326 19.9445L21.9201 22.457C21.5674 22.8098 20.9953 22.8098 20.6425 22.457Z"
            fill="#1A4D6D"
          />
        </svg>
      ),
      title: "Type",
      sec_title: "Pets allowed",
    },
    {
      img: (
        <svg width="32" height="24" viewBox="0 0 32 24" fill="none">
          <path
            d="M28.4209 10.7557C28.1722 10.7557 27.9337 10.6569 27.7579 10.481C24.6173 7.34042 20.4416 5.6108 16 5.6108C11.5584 5.6108 7.38277 7.34042 4.24209 10.4811C4.06627 10.6569 3.82784 10.7557 3.57921 10.7557C3.33059 10.7557 3.09215 10.6569 2.91634 10.4811L0.274593 7.83948C-0.0915311 7.47336 -0.0915311 6.8798 0.274593 6.51367C2.39721 4.39105 4.87252 2.74743 7.63183 1.6285C10.2966 0.547874 13.112 0 16 0C18.8879 0 21.7034 0.547936 24.3681 1.6285C27.1274 2.74743 29.6028 4.39105 31.7254 6.51367C32.0915 6.87974 32.0915 7.47336 31.7254 7.83948L29.0838 10.4811C28.908 10.6569 28.6695 10.7557 28.4209 10.7557Z"
            fill="#1A4D6D"
          />
          <path
            d="M22.9489 16.2078C22.7002 16.2078 22.4618 16.109 22.286 15.9332C20.607 14.2542 18.3747 13.3296 16.0003 13.3296C13.6259 13.3296 11.3936 14.2542 9.71462 15.9332C9.53881 16.109 9.30038 16.2078 9.05175 16.2078C8.80306 16.2078 8.56463 16.109 8.38881 15.9332L5.74719 13.2916C5.38113 12.9254 5.38113 12.3319 5.74726 11.9657C8.48594 9.227 12.1272 7.71875 16.0004 7.71875C19.8735 7.71875 23.5148 9.227 26.2535 11.9657C26.6195 12.3319 26.6196 12.9254 26.2535 13.2916L23.6119 15.9332C23.436 16.109 23.1975 16.2078 22.9489 16.2078Z"
            fill="#1A4D6D"
          />
          <path
            d="M16.0001 23.216C13.8574 23.216 12.1143 21.4901 12.1143 19.3687C12.1143 17.2474 13.8574 15.5215 16.0001 15.5215C18.1427 15.5215 19.8859 17.2474 19.8859 19.3687C19.8859 21.4901 18.1427 23.216 16.0001 23.216Z"
            fill="#1A4D6D"
          />
        </svg>
      ),
      title: "Guests",
      sec_title: "Wi-Fi",
    },
    {
      img: (
        <svg width="28" height="31" viewBox="0 0 28 31" fill="none">
          <path
            d="M0.232422 14.9346C0.601112 16.7879 1.46403 18.5076 2.72989 19.9108C4.87782 22.2465 8.15162 23.545 12.4434 23.796V22.8169C12.4434 21.9577 13.1398 21.2612 13.9991 21.2612C14.8584 21.2612 15.5548 21.9577 15.5548 22.8169V23.8048C17.4383 23.7234 19.2974 23.3495 21.0657 22.6972C21.6657 22.469 22.2465 22.1936 22.8029 21.8731C22.8206 21.8591 22.8392 21.8467 22.8585 21.8353C25.4124 20.3495 27.2015 17.835 27.7683 14.9351C25.2781 16.8881 19.51 17.9226 14.0006 17.9226C8.49076 17.9221 2.72214 16.8875 0.232422 14.9346Z"
            fill="#1A4D6D"
          />
          <path
            d="M28 12.7566C27.9948 10.8051 22.2469 8.63184 14 8.63184C5.74947 8.63184 0 10.8067 0 12.7592C0 14.7117 5.74947 16.8866 14 16.8866C22.193 16.8866 27.917 14.7418 27.9964 12.8002L27.9958 12.7837C27.9959 12.7742 28 12.7659 28 12.7566ZM2.59029 14.0027C2.3808 14.0027 2.19152 13.8762 2.1111 13.6827C2.03073 13.4888 2.07532 13.2658 2.22365 13.1174L4.81653 10.5246C5.01926 10.3254 5.34548 10.3265 5.54668 10.5277C5.74789 10.7289 5.74947 11.0546 5.5498 11.2578L2.95692 13.8507C2.8594 13.9482 2.7277 14.0027 2.59029 14.0027ZM4.66455 15.0399C4.45506 15.0399 4.26578 14.9133 4.18536 14.7199C4.105 14.5259 4.14958 14.303 4.29792 14.1547L8.4465 10.0061C8.64929 9.80693 8.97545 9.80799 9.17666 10.0092C9.37786 10.2104 9.37945 10.5361 9.17977 10.7393L5.03119 14.8879C4.93373 14.9854 4.80202 15.0399 4.66455 15.0399ZM7.25748 15.5585C7.048 15.5585 6.85872 15.4319 6.77829 15.2385C6.69793 15.0446 6.74252 14.8216 6.89085 14.6732L12.0766 9.48747C12.2794 9.28832 12.6055 9.28938 12.8068 9.49059C13.008 9.69179 13.0095 10.0175 12.8099 10.2207L7.62412 15.4065C7.5266 15.504 7.39489 15.5585 7.25748 15.5585ZM9.85036 16.077C9.64087 16.077 9.45159 15.9505 9.37117 15.757C9.2908 15.5631 9.33539 15.3401 9.48372 15.1918L15.1881 9.48741C15.3188 9.35465 15.5107 9.30178 15.6906 9.34948C15.8705 9.39718 16.0116 9.5377 16.0593 9.71817C16.107 9.89811 16.0541 10.09 15.9213 10.2207L10.217 15.925C10.1195 16.0226 9.98776 16.077 9.85036 16.077ZM13.3284 15.9251C13.1256 16.1242 12.7995 16.1232 12.5983 15.922C12.3971 15.7208 12.3955 15.3951 12.5951 15.1918L17.7809 10.0061C17.9115 9.87332 18.1035 9.82044 18.2834 9.86815C18.4633 9.91585 18.6044 10.0564 18.6521 10.2368C18.6998 10.4168 18.6469 10.6086 18.5142 10.7393L13.3284 15.9251ZM16.0733 16.077C15.8638 16.077 15.6745 15.9505 15.5941 15.757C15.5137 15.5631 15.5583 15.3401 15.7066 15.1918L20.3738 10.5246C20.5045 10.3918 20.6964 10.3389 20.8763 10.3866C21.0563 10.4343 21.1973 10.5749 21.245 10.7553C21.2927 10.9353 21.2399 11.1271 21.1071 11.2578L16.4399 15.925C16.3424 16.0226 16.2107 16.077 16.0733 16.077ZM19.7033 15.5585C19.4938 15.5585 19.3045 15.4319 19.2242 15.2385C19.1438 15.0446 19.1884 14.8216 19.3367 14.6732L23.4853 10.5246C23.616 10.3918 23.8079 10.3389 23.9878 10.3866C24.1678 10.4343 24.3088 10.5749 24.3565 10.7553C24.4042 10.9353 24.3513 11.1271 24.2186 11.2578L20.07 15.4064C19.9724 15.504 19.8407 15.5585 19.7033 15.5585ZM25.7743 12.8136L23.7 14.8879C23.4972 15.0871 23.171 15.086 22.9698 14.8848C22.7686 14.6836 22.7671 14.3579 22.9667 14.1547L25.041 12.0803C25.1717 11.9476 25.3636 11.8947 25.5435 11.9424C25.7235 11.9901 25.8645 12.1306 25.9122 12.3111C25.9599 12.491 25.9071 12.683 25.7743 12.8136Z"
            fill="#1A4D6D"
          />
          <path
            d="M23.526 22.6436C23.497 22.6612 23.4705 22.6793 23.441 22.697C23.4223 22.712 23.4026 22.7254 23.3824 22.7374C23.1335 22.8821 22.8773 23.0128 22.6201 23.1409L25.1051 27.8983C25.1663 28.0238 25.2768 28.1182 25.4106 28.1592C25.5443 28.2001 25.6885 28.1841 25.8099 28.1151C26.0598 27.9808 26.1547 27.6696 26.0215 27.4187L23.526 22.6436Z"
            fill="#1A4D6D"
          />
          <path
            d="M1.97653 27.3981C1.91121 27.5204 1.89823 27.6641 1.94023 27.7963C1.98223 27.9285 2.07611 28.038 2.20006 28.1002C2.45261 28.2288 2.7622 28.1297 2.89238 27.8777L5.36653 23.1416C5.0533 22.9849 4.75046 22.818 4.4585 22.6406L1.97653 27.3981Z"
            fill="#1A4D6D"
          />
          <path
            d="M13.999 22.2988C13.7128 22.2994 13.4809 22.5312 13.4805 22.8174V29.5589C13.4805 29.8452 13.7128 30.0774 13.999 30.0774C14.2853 30.0774 14.5176 29.8451 14.5176 29.5589V22.8174C14.5171 22.5312 14.2853 22.2988 13.999 22.2988Z"
            fill="#1A4D6D"
          />
          <path
            d="M10.3315 5.64176L10.1236 5.89014C9.93999 6.11002 9.96901 6.43724 10.1884 6.62082C10.2859 6.70171 10.4036 6.74166 10.5213 6.74166C10.6696 6.74166 10.8169 6.67839 10.9185 6.55702L11.127 6.30811C11.7685 5.54113 11.7685 4.42724 11.126 3.65873C10.8065 3.27705 10.8065 2.72267 11.126 2.34105L12.3711 0.852194C12.5552 0.632307 12.5261 0.305092 12.3063 0.12151C12.0869 -0.0631284 11.7592 -0.0340491 11.5756 0.186307L10.3305 1.67517C9.68849 2.44268 9.68849 3.55657 10.3315 4.32455C10.6504 4.70629 10.6504 5.26061 10.3315 5.64176Z"
            fill="#1A4D6D"
          />
          <path
            d="M13.4429 5.64126L13.2349 5.88964C13.0513 6.10952 13.0803 6.43674 13.2997 6.62032C13.3972 6.70121 13.5149 6.74116 13.6326 6.74116C13.7809 6.74116 13.9282 6.67789 14.0298 6.55652L14.2383 6.30761C14.8803 5.54063 14.8803 4.42674 14.2373 3.65823C13.9178 3.27655 13.9178 2.72217 14.2373 2.34055L15.4824 0.851694C15.6655 0.631808 15.637 0.304593 15.4171 0.121011C15.1962 -0.0636275 14.87 -0.0330208 14.6864 0.185808L13.4418 1.67467C12.7998 2.44218 12.7998 3.55607 13.4429 4.32405C13.7618 4.70579 13.7618 5.26011 13.4429 5.64126Z"
            fill="#1A4D6D"
          />
          <path
            d="M16.5552 5.64126L16.3472 5.88964C16.1636 6.10952 16.1922 6.43674 16.412 6.62032C16.509 6.70121 16.6272 6.74116 16.7444 6.74116C16.8927 6.74116 17.04 6.67789 17.1422 6.55652L17.3501 6.30761C17.9921 5.54063 17.9921 4.42674 17.3491 3.65823C17.0301 3.27655 17.0301 2.72217 17.3496 2.34055L18.5942 0.851694C18.7772 0.631808 18.7487 0.304593 18.5289 0.121011C18.308 -0.0636275 17.9818 -0.0330208 17.7982 0.185808L16.5541 1.67467C15.9121 2.44218 15.9121 3.55607 16.5552 4.32405C16.8741 4.70579 16.8741 5.25959 16.5552 5.64126Z"
            fill="#1A4D6D"
          />
        </svg>
      ),
      title: "Cabins",
      sec_title: "BBQ",
    },
    {
      img: (
        <svg width="28" height="29" viewBox="0 0 28 29" fill="none">
          <path
            d="M11 15.0771H18V16.5471C18.5807 16.832 19.1083 17.2142 19.56 17.6771C19.6998 17.5364 19.8466 17.4029 20 17.2771V3.07715C20 2.81193 20.1054 2.55758 20.2929 2.37004C20.4804 2.18251 20.7348 2.07715 21 2.07715C21.2652 2.07715 21.5196 2.18251 21.7071 2.37004C21.8946 2.55758 22 2.81193 22 3.07715C22 3.34237 22.1054 3.59672 22.2929 3.78426C22.4804 3.97179 22.7348 4.07715 23 4.07715C23.2652 4.07715 23.5196 3.97179 23.7071 3.78426C23.8946 3.59672 24 3.34237 24 3.07715C24 2.2815 23.6839 1.51844 23.1213 0.955828C22.5587 0.393219 21.7956 0.0771484 21 0.0771484C20.2044 0.0771484 19.4413 0.393219 18.8787 0.955828C18.3161 1.51844 18 2.2815 18 3.07715V7.07715H11V3.07715C11 2.81193 11.1054 2.55758 11.2929 2.37004C11.4804 2.18251 11.7348 2.07715 12 2.07715C12.2652 2.07715 12.5196 2.18251 12.7071 2.37004C12.8946 2.55758 13 2.81193 13 3.07715C13 3.34237 13.1054 3.59672 13.2929 3.78426C13.4804 3.97179 13.7348 4.07715 14 4.07715C14.2652 4.07715 14.5196 3.97179 14.7071 3.78426C14.8946 3.59672 15 3.34237 15 3.07715C15 2.2815 14.6839 1.51844 14.1213 0.955828C13.5587 0.393219 12.7956 0.0771484 12 0.0771484C11.2044 0.0771484 10.4413 0.393219 9.87868 0.955828C9.31607 1.51844 9 2.2815 9 3.07715V16.1071C9.70763 16.1816 10.3903 16.4103 11 16.7771V15.0771ZM18 9.07715V13.0771H11V9.07715H18Z"
            fill="#1A4D6D"
          />
          <path
            d="M27 20.0771C26.771 20.0637 26.5486 19.9947 26.3523 19.8761C26.1559 19.7574 25.9914 19.5927 25.873 19.3961C25.5755 18.9875 25.1857 18.655 24.7352 18.4257C24.2847 18.1964 23.7864 18.0769 23.281 18.0769C22.7756 18.0769 22.2773 18.1964 21.8268 18.4257C21.3763 18.655 20.9865 18.9875 20.689 19.3961C20.5815 19.6017 20.4198 19.7739 20.2214 19.8941C20.023 20.0143 19.7955 20.0778 19.5635 20.0778C19.3315 20.0778 19.104 20.0143 18.9056 19.8941C18.7072 19.7739 18.5455 19.6017 18.438 19.3961C18.1412 18.9873 17.7518 18.6546 17.3018 18.4252C16.8517 18.1958 16.3537 18.0762 15.8485 18.0762C15.3433 18.0762 14.8453 18.1958 14.3952 18.4252C13.9452 18.6546 13.5558 18.9873 13.259 19.3961C13.1419 19.5927 12.9783 19.7576 12.7827 19.8763C12.5871 19.995 12.3654 20.064 12.137 20.0771C11.9088 20.0636 11.6873 19.9945 11.4918 19.876C11.2963 19.7575 11.1326 19.5932 11.015 19.3971C10.712 18.9947 10.3213 18.6666 9.87251 18.4379C9.42371 18.2092 8.92865 18.0858 8.425 18.0771C7.9216 18.0858 7.4268 18.2091 6.97818 18.4377C6.52957 18.6662 6.13895 18.994 5.836 19.3961C5.71878 19.5928 5.5551 19.7578 5.35931 19.8765C5.16352 19.9952 4.9416 20.0641 4.713 20.0771C4.4844 20.0641 4.26248 19.9952 4.06669 19.8765C3.8709 19.7578 3.70722 19.5928 3.59 19.3961C3.28679 18.9941 2.89598 18.6663 2.44721 18.4378C1.99845 18.2092 1.50353 18.0859 1 18.0771C0.734784 18.0771 0.48043 18.1825 0.292893 18.37C0.105357 18.5576 0 18.8119 0 19.0771V28.0771H28V21.0771C28 20.8119 27.8946 20.5576 27.7071 20.37C27.5196 20.1825 27.2652 20.0771 27 20.0771Z"
            fill="#1A4D6D"
          />
        </svg>
      ),
      title: "Beds",
      sec_title: "Swimming pool",
    },
    {
      img: (
        <svg width="28" height="29" viewBox="0 0 28 29" fill="none">
          <path
            d="M8.84368 5.60999H10.4843C10.4843 4.67801 10.1531 4.16132 9.91123 3.78403C9.71562 3.47893 9.5976 3.29474 9.5976 2.84352C9.5976 2.39223 9.71567 2.2081 9.91123 1.903C10.1531 1.52577 10.4843 1.00908 10.4843 0.0771484H8.84368C8.84368 0.528375 8.72566 0.712508 8.5301 1.01755C8.28822 1.39484 7.95703 1.91153 7.95703 2.84352C7.95703 3.77545 8.28827 4.29213 8.5301 4.66942C8.72561 4.97452 8.84368 5.15871 8.84368 5.60999Z"
            fill="#1A4D6D"
          />
          <path
            d="M13.623 5.60999H15.2636C15.2636 4.67801 14.9324 4.16132 14.6905 3.78403C14.495 3.47893 14.377 3.2948 14.377 2.84352C14.377 2.39223 14.495 2.2081 14.6905 1.903C14.9324 1.52577 15.2636 1.00908 15.2636 0.0771484H13.623C13.623 0.528375 13.505 0.712508 13.3094 1.01761C13.0676 1.39484 12.7363 1.91153 12.7363 2.84352C12.7363 3.77545 13.0675 4.29213 13.3093 4.66942C13.505 4.97452 13.623 5.15871 13.623 5.60999Z"
            fill="#1A4D6D"
          />
          <path
            d="M18.4023 5.60999H20.0429C20.0429 4.67801 19.7117 4.16132 19.4698 3.78403C19.2742 3.47893 19.1562 3.29474 19.1562 2.84352C19.1562 2.39223 19.2742 2.2081 19.4698 1.903C19.7117 1.52577 20.0429 1.00908 20.0429 0.0771484H18.4023C18.4023 0.528375 18.2843 0.712508 18.0887 1.01755C17.8468 1.39484 17.5156 1.91153 17.5156 2.84352C17.5156 3.77545 17.8469 4.29213 18.0887 4.66942C18.2842 4.97452 18.4023 5.15871 18.4023 5.60999Z"
            fill="#1A4D6D"
          />
          <path
            d="M0 11.9729C0 11.1411 0.674301 10.4668 1.50609 10.4668C2.33789 10.4668 3.01219 11.1411 3.01219 11.9729V12.7894C3.01219 13.6212 2.33789 14.2955 1.50609 14.2955C0.674301 14.2955 0 13.6212 0 12.7894V11.9729Z"
            fill="#1A4D6D"
          />
          <path
            d="M13.5781 12.3811C13.5781 11.3239 14.4352 10.4668 15.4925 10.4668H26.0854C27.1427 10.4668 27.9998 11.3239 27.9998 12.3811C27.9998 13.4384 27.1427 14.2955 26.0854 14.2955H15.4925C14.4352 14.2955 13.5781 13.4384 13.5781 12.3811Z"
            fill="#1A4D6D"
          />
          <path
            d="M13.5784 18.6621C13.5784 20.1675 12.3581 21.3878 10.8527 21.3878H5.73781C4.23249 21.3878 3.01219 20.1675 3.01219 18.6621V17.4426C3.01219 16.6108 2.33789 15.9365 1.50609 15.9365C0.674302 15.9365 0 16.6108 0 17.4426V21.456C0 21.9508 0.12238 22.4379 0.356239 22.8739L1.64102 25.2694C1.8435 25.647 2.23717 25.8825 2.66555 25.8825H2.73082C3.33684 25.8825 3.82812 26.3738 3.82812 26.9798V27.2568C3.82812 27.7099 4.19539 28.0771 4.64844 28.0771C5.10148 28.0771 5.46875 27.7099 5.46875 27.2568V26.9798C5.46875 26.3738 5.96003 25.8825 6.56606 25.8825H21.4339C22.04 25.8825 22.5312 26.3738 22.5312 26.9798V27.2568C22.5312 27.7099 22.8985 28.0771 23.3516 28.0771C23.8046 28.0771 24.1719 27.7099 24.1719 27.2568V26.9798C24.1719 26.3738 24.6632 25.8825 25.2692 25.8825H25.3345C25.7628 25.8825 26.1565 25.647 26.359 25.2694L27.6438 22.8739C27.8776 22.4379 28 21.9508 28 21.456V18.9365C28 17.2797 26.6569 15.9365 25 15.9365H16.304C14.7987 15.9365 13.5784 17.1568 13.5784 18.6621Z"
            fill="#1A4D6D"
          />
          <path
            d="M4.65283 13.4668C4.65283 11.8099 5.99598 10.4668 7.65283 10.4668H8.93732C10.5942 10.4668 11.9373 11.8099 11.9373 13.4668V16.7466C11.9373 18.4035 10.5942 19.7466 8.93732 19.7466H7.65283C5.99598 19.7466 4.65283 18.4035 4.65283 16.7466V13.4668Z"
            fill="#1A4D6D"
          />
        </svg>
      ),
      title: "Length",
      sec_title: "Jacuzzi",
    },
    {
      img: (
        <svg width="23" height="29" viewBox="0 0 23 29" fill="none">
          <path
            d="M5.5125 0.0771484H0V1.71777H4.33125L5.97187 6.63965H7.69453L5.5125 0.0771484Z"
            fill="#1A4D6D"
          />
          <path
            d="M15.586 17.3037C15.586 16.5154 15.4194 15.7247 15.1054 15.0182L15.1038 15.0166C14.7161 14.1506 14.6344 13.11 14.8619 12.0141C14.8951 11.8601 14.9472 11.7136 14.9876 11.5615H4.69217C5.00898 12.7393 4.95505 14.0216 4.48458 15.2401C4.10007 16.2479 4.0007 17.3318 4.19621 18.37C4.60576 20.6015 6.4658 22.6175 9.02353 22.9702V26.4365H4.92197V28.0771H14.7657V26.4365H10.6642V22.9679C13.5875 22.5427 15.586 20.0732 15.586 17.3037Z"
            fill="#1A4D6D"
          />
          <path
            d="M4.13447 9.9209H7.07114L5.97192 6.63965H2.92041L4.13447 9.9209Z"
            fill="#1A4D6D"
          />
          <path
            d="M15.5529 9.9209L16.7669 6.63965H7.69434L8.79355 9.9209H15.5529Z"
            fill="#1A4D6D"
          />
          <path
            d="M16.4065 1.71777C14.1246 1.71777 12.1656 3.06609 11.2402 4.99902H19.1269L16.6788 11.5832C16.5907 11.8251 16.5234 12.0926 16.4657 12.3602C16.4044 12.6557 16.3997 12.9316 16.4009 13.2038C16.4054 13.2038 16.41 13.2054 16.4144 13.2054C17.4959 13.2054 18.5485 12.9057 19.4842 12.3106C21.1521 11.2499 22.1486 9.43702 22.1486 7.45996C22.1486 4.29405 19.5724 1.71777 16.4065 1.71777Z"
            fill="#1A4D6D"
          />
        </svg>
      ),
      title: "Draft",
      sec_title: "Cocktail bar",
    },
  ];

  let extras = [
    {
      title: "Transport",
      cost: " + €25",
      icon: (
        <svg
          width="30"
          height="26"
          viewBox="0 0 30 26"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12.1048 0.00044063C11.7715 0.00044063 11.4545 0.282598 11.3628 0.60179L10.7593 2.32207C10.6671 2.64126 10.881 2.92342 11.2138 2.92342H18.7686C19.101 2.92342 19.3148 2.64126 19.2227 2.32207L18.6191 0.601349C18.527 0.282158 18.21 0 17.8772 0H12.1048V0.00044063Z"
            fill="#1A4D6D"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M20.1527 15.8825H9.82879C9.39012 15.8825 9.29137 16.3895 9.49373 16.8789C9.91829 17.9149 11.046 18.8928 12.1204 18.6106H17.8615C18.9729 18.6106 20.0636 17.9145 20.4878 16.8789C20.6901 16.3895 20.5865 15.9464 20.1527 15.8825ZM3.22761 15.8415C3.042 16.4151 2.82554 17.5499 3.84527 17.922C4.68117 18.2266 6.44245 18.4471 7.3793 18.5904C8.28177 18.7257 8.50617 18.1931 8.19448 17.3982C7.609 15.9262 6.28859 15.614 5.04885 15.4006C3.81089 15.1868 3.36737 15.4117 3.22761 15.8415ZM24.9335 15.4006C23.6955 15.614 22.3729 15.9257 21.7901 17.3982C21.4753 18.1931 21.7006 18.7253 22.6031 18.5904C23.5426 18.4475 25.3012 18.2271 26.1371 17.922C27.1564 17.5499 26.943 16.4151 26.7543 15.8415C26.6141 15.4117 26.1732 15.1868 24.9335 15.4006ZM14.9914 5.47838C13.0555 5.48102 10.9636 5.54715 9.19305 5.66927C8.52293 5.71512 7.90747 6.07752 7.49393 6.74588C6.60778 8.18313 5.81729 9.53572 5.31955 11.04C5.31955 11.04 10.8715 11.5928 14.9914 11.5928C19.1127 11.5928 24.665 11.04 24.665 11.04C24.1646 9.53572 23.3768 8.18313 22.4906 6.74588C22.0771 6.07752 21.4599 5.71512 20.7889 5.66927C19.021 5.54715 16.9268 5.48102 14.9914 5.47838ZM14.9914 4.12799C17.239 4.12799 19.5355 4.11652 21.731 4.42205C22.7503 4.56445 23.4046 5.16183 23.8754 5.85488C24.9476 7.43232 25.6389 9.09882 26.2425 10.7847H28.9335C29.6848 10.7847 30.1327 11.3675 29.9374 12.091C29.7236 12.8925 29.4802 13.2849 28.3044 13.5582L27.8565 13.6618C28.2057 14.3298 28.4631 15.0374 28.4631 15.6687V20.8485C28.4631 21.7144 27.8635 22.4471 27.1661 22.7204V25.1452C27.1661 25.6187 26.7847 25.9996 26.3117 25.9996H23.8886C23.416 25.9996 23.0342 25.6187 23.0342 25.1452V22.8399H6.94945V25.1452C6.94945 25.6187 6.56854 25.9996 6.09504 25.9996H3.67245C3.19939 25.9996 2.81848 25.6187 2.81848 25.1452V22.7204C2.12014 22.4471 1.51879 21.717 1.51879 20.8485V15.6691C1.51879 15.0378 1.77538 14.3298 2.12675 13.6623L1.67662 13.5587C0.503462 13.2853 0.260101 12.893 0.0445145 12.0915C-0.147706 11.368 0.30022 10.7852 1.04838 10.7852H3.74167C4.34522 9.0997 5.0343 7.43276 6.10651 5.85532C6.57736 5.16183 7.23426 4.56445 8.25135 4.42249C10.4491 4.11652 12.743 4.12799 14.9914 4.12799Z"
            fill="#1A4D6D"
          />
        </svg>
      ),
    },
    {
      title: "Wi-Fi",
      cost: " + €10",
      icon: (
        <svg width="32" height="24" viewBox="0 0 32 24" fill="none">
          <path
            d="M28.4209 10.7557C28.1722 10.7557 27.9337 10.6569 27.7579 10.481C24.6173 7.34042 20.4416 5.6108 16 5.6108C11.5584 5.6108 7.38277 7.34042 4.24209 10.4811C4.06627 10.6569 3.82784 10.7557 3.57921 10.7557C3.33059 10.7557 3.09215 10.6569 2.91634 10.4811L0.274593 7.83948C-0.0915311 7.47336 -0.0915311 6.8798 0.274593 6.51367C2.39721 4.39105 4.87252 2.74743 7.63183 1.6285C10.2966 0.547874 13.112 0 16 0C18.8879 0 21.7034 0.547936 24.3681 1.6285C27.1274 2.74743 29.6028 4.39105 31.7254 6.51367C32.0915 6.87974 32.0915 7.47336 31.7254 7.83948L29.0838 10.4811C28.908 10.6569 28.6695 10.7557 28.4209 10.7557Z"
            fill="#1A4D6D"
          />
          <path
            d="M22.9489 16.2078C22.7002 16.2078 22.4618 16.109 22.286 15.9332C20.607 14.2542 18.3747 13.3296 16.0003 13.3296C13.6259 13.3296 11.3936 14.2542 9.71462 15.9332C9.53881 16.109 9.30038 16.2078 9.05175 16.2078C8.80306 16.2078 8.56463 16.109 8.38881 15.9332L5.74719 13.2916C5.38113 12.9254 5.38113 12.3319 5.74726 11.9657C8.48594 9.227 12.1272 7.71875 16.0004 7.71875C19.8735 7.71875 23.5148 9.227 26.2535 11.9657C26.6195 12.3319 26.6196 12.9254 26.2535 13.2916L23.6119 15.9332C23.436 16.109 23.1975 16.2078 22.9489 16.2078Z"
            fill="#1A4D6D"
          />
          <path
            d="M16.0001 23.216C13.8574 23.216 12.1143 21.4901 12.1143 19.3687C12.1143 17.2474 13.8574 15.5215 16.0001 15.5215C18.1427 15.5215 19.8859 17.2474 19.8859 19.3687C19.8859 21.4901 18.1427 23.216 16.0001 23.216Z"
            fill="#1A4D6D"
          />
        </svg>
      ),
    },
    {
      title: "Fuel Cost Free",
      cost: " + €50",
      icon: (
        <svg width="32" height="24" viewBox="0 0 20 26" fill="none">
          <path
            d="M14.3486 3.16541L14.7446 2.76947L17.0702 5.09508L16.6742 5.49101L14.3486 3.16541Z"
            fill="#1A4D6D"
          />
          <path
            d="M19.7019 4.25406L18.5904 5.36535C18.5021 5.45353 18.3824 5.50306 18.2576 5.50306C18.1328 5.50306 18.0131 5.45353 17.9248 5.36535L14.4737 1.91406C14.3858 1.82565 14.3364 1.70603 14.3364 1.58134C14.3364 1.45665 14.3858 1.33704 14.4737 1.24862L15.585 0.137122C15.6735 0.0492886 15.7931 0 15.9178 0C16.0425 0 16.1621 0.0492886 16.2506 0.137122L19.7019 3.58842C19.7898 3.67692 19.839 3.79655 19.839 3.92124C19.839 4.04593 19.7898 4.16556 19.7019 4.25406Z"
            fill="#1A4D6D"
          />
          <path
            d="M7.32422 16.517C7.32422 17.1031 7.55706 17.6652 7.97151 18.0797C8.38597 18.4941 8.94809 18.727 9.53422 18.727C10.1203 18.727 10.6825 18.4941 11.0969 18.0797C11.5114 17.6652 11.7442 17.1031 11.7442 16.517C11.7442 15.5529 10.2831 12.8979 9.53422 11.6389C8.7853 12.8985 7.32422 15.5529 7.32422 16.517Z"
            fill="#1A4D6D"
          />
          <path
            d="M18.5772 7.96923L11.8022 1.19624C11.6463 1.04019 11.4612 0.916477 11.2574 0.832189C11.0536 0.747901 10.8352 0.704705 10.6147 0.705081H1.92501C1.41468 0.705779 0.925454 0.908817 0.564595 1.26968C0.203736 1.63053 0.000698606 2.11976 0 2.6301V24.073C0.00069711 24.5835 0.20367 25.0729 0.564471 25.4341C0.925272 25.7953 1.4145 25.9988 1.92501 26H17.1433C17.654 25.9992 18.1435 25.7959 18.5044 25.4346C18.8652 25.0733 19.0681 24.5836 19.0683 24.073V9.1567C19.0689 8.93615 19.0258 8.71766 18.9415 8.51385C18.8572 8.31004 18.7334 8.12494 18.5772 7.96923ZM6.44211 3.39466L2.76676 7.07C2.66971 7.16701 2.54607 7.23307 2.41148 7.25982C2.27689 7.28657 2.13739 7.27281 2.01062 7.22029C1.88384 7.16776 1.77549 7.07882 1.69926 6.96472C1.62303 6.85062 1.58234 6.71647 1.58234 6.57925V3.37475C1.58272 3.06605 1.7055 2.7701 1.92377 2.5518C2.14203 2.3335 2.43796 2.21067 2.74665 2.21024H5.95136C6.08858 2.21023 6.22272 2.25092 6.33683 2.32715C6.45093 2.40338 6.53987 2.51174 6.59239 2.63851C6.64492 2.76528 6.65868 2.90478 6.63193 3.03938C6.60518 3.17397 6.53912 3.29761 6.44211 3.39466ZM9.53367 19.1381C8.839 19.1371 8.17304 18.8608 7.68184 18.3696C7.19063 17.8784 6.91427 17.2124 6.91336 16.5177C6.91336 15.1418 9.25904 11.2974 9.35898 11.1349C9.37867 11.1067 9.40489 11.0837 9.43539 11.0678C9.46589 11.0519 9.49978 11.0436 9.53417 11.0436C9.56857 11.0436 9.60246 11.0519 9.63296 11.0678C9.66346 11.0837 9.68968 11.1067 9.70937 11.1349C9.8091 11.2974 12.155 15.1422 12.155 16.5177C12.154 17.2126 11.8775 17.8787 11.3861 18.3699C10.8947 18.8611 10.2285 19.1374 9.53367 19.1381Z"
            fill="#1A4D6D"
          />
        </svg>
      ),
    },
  ];

  const [dates, setDates] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  ]);

  const [dateModal, setDateModal] = useState(false);
  const [apaPolicyModal, setApaPolicyModal] = useState(false);

  // handle gallery slider change
  const handleGalleryModal = (status) => {
    if (status === "open") {
      setGalleryModal(true);
      document.body.style.overflow = "hidden";
    } else {
      setGalleryModal(false);
      document.body.style.overflow = "auto";
    }
  };

  return (
    <div className="yachtDetail-page">
      <Helmet>
        <title>Cyan | Motorboat Azimut 62</title>
      </Helmet>
      <div className="cs_container">
        <div className="page-breadcrumbs d-flex align-items-center event-bread-crumbs">
          <div className="breadcrumbs-left">
            <span className="text-gr font-weight-bold">Yacht List</span>
            <span className="crumbs-icon">
              <ChevronRight className="text-sec" />
            </span>
            <span className="text-pr font-weight-bold">Yacht Details</span>
          </div>
          <div className="breadcrumbs-right">
            <div className="yacht-detail-top-shares-btns">
              <button className="yacht-detail-share-btn">
                <img src={ShareImg} alt="" /> Share
              </button>
              <button
                className="yacht-detail-fav-btn"
                onClick={() => SetFavYacht(!favYacht)}
              >
                <FavIcon liked={favYacht} /> Add to Favorites
              </button>
            </div>
          </div>
        </div>
        {/* yacht detail slider */}
        <div className="yacht-detail-slider-wrapper">
          <div
            className="yacht-detail-container"
            // after
            // navigation={{
            //   prevEl: navigationPrevRef.current,
            //   nextEl: navigationNextRef.current,
            // }}
            // // autoplay={{ disableOnInteraction: false, delay: 4500 }}
            // speed={500}
            // initialSlide={0}
            // // pagination={{
            // //   clickable: true,
            // // }}
            // spaceBetween={15}
            // grabCursor
            // loop

            // before
            // onBeforeInit={(swiper) => {
            //   swiper.params.navigation.prevEl = navigationPrevRef.current;
            //   swiper.params.navigation.nextEl = navigationNextRef.current;
            //   swiper.params.pagination.el = ".yacht-slider-paging";
            //   swiper.params.pagination.bulletActiveClass = "active-paging-item";
            //   swiper.params.pagination.bulletClass =
            //     "custom-paging-item-yacht-slider";
            //   swiper.params.pagination.clickable = true;
            //   swiper.params.pagination.renderBullet = (index, className) => {
            //     if (index <= 7) {
            //       return ` <span data-images="${
            //         images.length - 8
            //       }" class="yacht-detail-bullets ${className} ${
            //         index === 7 ? "last-paging" : ""
            //       }">
            //                             <img class="detail-bullet-img" src=${
            //                               images[index]
            //                             } alt="" />
            //                             </span>`;
            //     } else {
            //       return '<span class="disabled-pagings"></span>';
            //     }
            //   };
            // }}
          >
            {/* {images.slice(0, 8).map((image, index) => ( */}
            <div className="yacht-detail-slider-card">
              <div className="yacht-detail-slider-main-img">
                <img
                  className="yacht-detail-slider-img"
                  src={sliderImg}
                  alt="cyan"
                />
                <div
                  role="button"
                  onClick={() => handleGalleryModal("open")}
                  data-images={14}
                  className="yacht-detail-bullets last-paging"
                >
                  <img class="detail-bullet-img" src={sliderImg} alt="" />
                </div>
              </div>
              <div className="yacht-detail-slider-right-imgs">
                <img
                  className="yacht-detail-slider-img"
                  src={sliderImg}
                  alt="cyan"
                />
                <img
                  className="yacht-detail-slider-img"
                  src={sliderImg}
                  alt="cyan"
                />
              </div>
            </div>
            {/* ))} */}

            {/* <div
              ref={navigationPrevRef}
              className="yacht-detail-slider-cs-nav prev-bt"
            >
              <ChevronLeft />
            </div>
            <div
              ref={navigationNextRef}
              className="yacht-detail-slider-cs-nav next-bt"
            >
              <ChevronRight />
            </div> */}
          </div>
          {/* <div className="yacht-slider-paging"></div> */}
        </div>

        {/* yacht other details left/right part */}
        <div className="yacht-detail-row d-flex">
          {/* left */}
          <div className="yacht-detail-left">
            <h1 className="yacht-detail-main-title d-flex flex-wrap align-items-center">
              Motorboat Azimut 62 &nbsp;
              <button className="per-night-price-right-btn ms-md-3 my-2 py-2 border-0">
                Click for Brochure
              </button>
            </h1>
            <div className="d-flex justify-content-start align-items-center">
              <CustomRatings name="read-only" value={5} readOnly />
              &nbsp;
              <span className="font-weight-bold">5 </span>&nbsp;{" "}
              <span className="text-muted">(23)</span>
            </div>
            <div className="pt-3  d-flex align-items-center justify-content-start">
              <img src={LocationIcon} alt="" />
              <p className="text-sec pb-1 px-1">
                Crete, Agios Pipis Marina, Greece
              </p>
            </div>
            <div className="d-flex justify-content-start align-items-center about-length-yacht">
              <div className="d-flex justify-content-start align-items-center horse-people-meter">
                <span>12 </span>
                <span className="text-muted">Guests </span>
              </div>
              <div className="d-flex justify-content-start align-items-center horse-people-meter">
                <span className="text-muted">Year Built</span>
                <span>2010</span>
              </div>
              <div className="d-flex justify-content-start align-items-center horse-people-meter">
                <span>8 </span>
                <span className="text-muted"> metres</span>
              </div>
            </div>
            <div className="d-flex justify-content-start align-items-center">
              <div className="d-flex justify-content-start align-items-center horse-people-meter after-none">
                <span className="text-muted">Offered by </span>
                <a
                  href="/captain/0"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-pr font-weight-bold px-3"
                >
                  Cyan Group{" "}
                </a>
                {/* <button className="message-the-capt">
                  Message the captain
                </button> */}
              </div>
            </div>
            {/* characteristic */}
            <div className="yacht-detail-features-container">
              <h3>Characteristics </h3>
              <div className="yacht-detail-features-row">
                {characteristicData.map((data, ind) => {
                  return (
                    <div key={ind} className="p-sm-3 p-1 d-flex col-md-3 col-4">
                      <div
                        className={`yacht-detail-feature-box-img-area ${
                          data.padd ? "with-pl" : ""
                        }`}
                      >
                        {data?.icon ? (
                          data?.icon
                        ) : (
                          <img src={data.img} alt="" />
                        )}
                      </div>
                      <div className="yacht-detail-feature-box-right">
                        <span>{data.title}</span>
                        <span className="text-sec">{data.sec_title}</span>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>

            <div className="cs-hr-for-det"></div>
            <div className="yacht-detial-desc">
              <h3>Description of Motorboat Azimut 62</h3>
              <p className="text-gr">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                Tincidunt nulla ipsum at scelerisque at leo amet. Iaculis augue
                lectus amet.
              </p>
              <p className="text-gr">
                eget feugiat faucibus odio eu proin nunc. Leo, lorem mauris
                bibendum interdum porta duis tristique rhoncus. Tortor a,
                dictumst convallis viverra
              </p>
              <p className="text-gr">
                eget vitae vehicula enim consectetur facilisis purus,
              </p>
              <p className="text-gr">
                - quam. Vestibulum netus viverra.
                <br />
                - oin nunc. Leo, lorem mauris
                <br />
                - Iaculis augue lectus a<br />
              </p>
              <button className="cs_btn seemore-btn">See more</button>
            </div>
            {/*  */}
            <div className="cs-hr-for-det mt-3"></div>
            <div className="yacht-detail-features-container">
              <h3>Features of the boat</h3>
              <div className="yacht-detail-features-row">
                {featuresData.map((data, ind) => {
                  return (
                    <div key={ind} className="yacht-detail-feature-box">
                      <div
                        className={`yacht-detail-feature-box-img-area ${
                          data.padd ? "with-pl" : ""
                        }`}
                      >
                        {data?.img}
                        {/* <img src={data.img} alt="" /> */}
                      </div>
                      <div className="yacht-detail-feature-box-right">
                        <span>{data.sec_title}</span>
                        {/* <span>{data.title}</span> */}
                        {/* <span className="text-sec">{data.sec_title}</span> */}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
            <button className="cs_btn seemore-btn">See more</button>
            {/*  */}
            <div className="cs-hr-for-det mt-3"></div>
            <div className="yacht-detail-features-container">
              <h3>Extras</h3>
              <div className="d-flex flex-column flex-wrap">
                {extras.map((data, ind) => {
                  return (
                    <div className="col-md-9 py-3 px-2">
                      <div
                        key={ind}
                        className="d-flex yacht-detail-feature-box w-100"
                      >
                        <div className="d-flex">
                          <div className={`yacht-detail-feature-box-img-area `}>
                            {data?.icon ? (
                              data?.icon
                            ) : (
                              <img src={data.img} alt="" />
                            )}
                          </div>
                          <div className="mx-2">
                            <span>{data.title}</span>
                            <span className="text-sec">{data.cost}</span>
                          </div>
                        </div>
                        <div className="ml-auto pe-2">
                          <span className="text-sec">
                            <svg
                              width="28"
                              height="28"
                              viewBox="0 0 28 28"
                              fill="none"
                              className="me-2"
                            >
                              <path
                                d="M14 0C6.26875 0 0 6.26875 0 14C0 21.7313 6.26875 28 14 28C21.7313 28 28 21.7313 28 14C28 6.26875 21.7313 0 14 0ZM20 14.75C20 14.8875 19.8875 15 19.75 15H15V19.75C15 19.8875 14.8875 20 14.75 20H13.25C13.1125 20 13 19.8875 13 19.75V15H8.25C8.1125 15 8 14.8875 8 14.75V13.25C8 13.1125 8.1125 13 8.25 13H13V8.25C13 8.1125 13.1125 8 13.25 8H14.75C14.8875 8 15 8.1125 15 8.25V13H19.75C19.8875 13 20 13.1125 20 13.25V14.75Z"
                                fill="#3F8BBF"
                              />
                            </svg>
                            Add to your trip
                          </span>
                        </div>
                      </div>
                      <div className="cs-hr-for-det w-100 mt-1"></div>
                    </div>
                  );
                })}
              </div>
            </div>
            <button className="cs_btn seemore-btn">See more</button>

            {/*  */}
            {/* <div className="cs-hr-for-det mt-3"></div>
            <div className="yacht-detial-desc">
              <h3>Options & Services</h3>
              <p className="text-sec">Obligatory</p>
              <p className="text-gr">Transit Log</p>
              <div className="cs-hr-for-det mb-2"></div>
              <p className="text-gr">End cleaning</p>
              <p className="">
                Included in price: tender, base mooring place, outboard motor,
                towels, bedding, tourist tax, Wifi, Netflix, welcome package
              </p>
              <p className="text-sec">Optional</p>
              <p className="text-gr">Photo session 500u20ac - 2500u20ac</p>
              <div className="cs-hr-for-det mb-2"></div>
              <p className="text-gr">Late check out ( if possible)</p>
              <div className="cs-hr-for-det mb-2"></div>
              <p className="text-gr">Donut</p>
              <div className="cs-hr-for-det mb-2"></div>
              <p className="text-gr">Seabob (+deposit 500u20ac)</p>
              <div className="cs-hr-for-det mb-2"></div>
              <p className="text-gr">Early check in ( if possible)</p>
              <div className="cs-hr-for-det mb-2"></div>
              <p className="text-sec">
                Full Options <ChevronLeft className="text-gr rotate-down" />
              </p>
              <div className="cs-hr-for-det mb-2"></div>
            </div> */}
            <div className="yacht-detial-desc mt-md-4">
              <h3>Representative</h3>
              <div className="detail-yacht-owner-wrapper d-flex">
                <div className="detail-yacht-owner-left">
                  <img src={yachtOwnerProfile} alt="" />
                </div>
                <div className="detail-yacht-owner-right">
                  <a
                    href="/captain/0"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <p className="detail-owners-name">Cyan Group </p>
                  </a>
                  <p className="detail-owners-role text-sec">
                    Trip Coordinator
                  </p>
                  <div className="d-flex justify-content-start align-items-center">
                    <CustomRatings name="read-only" value={5} readOnly />
                    &nbsp;
                    <span className="font-weight-bold">5 </span>&nbsp;{" "}
                    <span className="text-muted">(23)</span>
                  </div>
                </div>
              </div>
              <div className="about-yacht-owner-details d-flex">
                <div className="detail-box-yachtowner">
                  <img src={calendarIcon} alt="" />
                  <span className="text-gr">Member since: </span>
                  <span>August 2022</span>
                </div>
                <div className="detail-box-yachtowner">
                  <img src={langIcon} alt="" />
                  <span className="text-gr">Languages: </span>
                  <span>English, French, Greek,Spanish</span>
                </div>
                <div className="detail-box-yachtowner">
                  <img src={inboxIcon} alt="" />
                  <span className="text-gr">Response rate: </span>
                  <span>100%</span>
                </div>
                <div className="detail-box-yachtowner">
                  <img src={responseIcon} alt="" />
                  <span className="text-gr">Response time: </span>
                  <span>Less than 1 hour</span>
                </div>
              </div>
            </div>
            <div className="cs-hr-for-det mt-3"></div>
          </div>
          {/* right column */}
          <div className="yacht-detail-right position-sticky  pt-md-5 px-2">
            <div className="yacht-detail-price-perNight pyt-3 pb-1 border border-0 border-bottom d-flex justify-content-between align-items-center">
              <div className="per-night-left">
                <h5>Price Per Day</h5>
                {/* <p className="text-gr">IntraDay booking type</p> */}
              </div>
              <div className="per-night-price-right-btn">200 € / Day</div>
            </div>
            <div className="yacht_detail_time_and_price_card">
              <h5 className="text-muted">Select your dates:</h5>
              <div className="yacht_detail_time_start_end border d-flex ">
                <div className="w-50 cursor-pointer user-select-none">
                  {/* <h5>14Oct </h5>
                  <span>7:00AM</span> */}
                  <h5
                    onClick={() => {
                      setDateModal(true);
                    }}
                    tabIndex="0"
                    role="button"
                  >
                    {dates[0]?.startDate
                      ? Moment(dates[0].startDate).format("DD-MM-YYYY") ||
                        "Starting date"
                      : "Starting date"}
                  </h5>
                  <span className="text-muted  d-block mx-auto mt-1">
                    {/* <input
                      className="border-0 outline-0"
                      type="time"
                      value="20:05"
                      readOnly
                    /> */}
                    20:05 am
                  </span>
                </div>
                <div className="w-50 cursor-pointer user-select-none">
                  <h5
                    onClick={() => {
                      setDateModal(true);
                    }}
                    tabIndex="0"
                    role="button"
                  >
                    {dates[0]?.endDate
                      ? Moment(dates[0].endDate).format("DD-MM-YYYY") ||
                        "Ending date"
                      : "Ending date"}
                  </h5>
                  <span className="text-muted  d-block mx-auto mt-1">
                    {/* <input
                      className="border-0 outline-0"
                      type="time"
                      value="00:00"
                    /> */}
                    20:05 pm
                  </span>
                </div>
              </div>
              <CustomModal openPopup={dateModal} setOpenPopup={setDateModal}>
                <DateRangePicker
                  ranges={dates}
                  onChange={(item) => {
                    setDates([item.selection]);
                  }}
                  moveRangeOnFirstSelection={true}
                  minDate={new Date()}
                  selectsStart={true}
                  startDate={dates[0].startDate}
                  endDate={dates[0].endDate}
                  inline={true}
                />
              </CustomModal>
              <hr />
              <div className="d-flex px-2 justify-content-between align-items-center">
                <h5 className="fw-light">Charter Rate (VAT included)</h5>
                <h5 className="text-sec fw-light">400 €</h5>
              </div>
              <div className="d-flex px-2 justify-content-between align-items-center">
                <h5 className="fw-light">Extras</h5>
                <h5 className="text-sec fw-light">400 €</h5>
              </div>
              <div className="d-flex px-2 justify-content-between align-items-center">
                <h5 className="fw-light">
                  APA{" "}
                  <svg
                    width="16"
                    height="15"
                    viewBox="0 0 16 15"
                    fill="none"
                    className="cursor-pointer"
                    onClick={() => setApaPolicyModal(true)}
                  >
                    <path
                      d="M8 14.0625C6.14348 14.0625 4.36301 13.3711 3.05025 12.1404C1.7375 10.9097 1 9.24048 1 7.5C1 5.75952 1.7375 4.09032 3.05025 2.85961C4.36301 1.6289 6.14348 0.9375 8 0.9375C9.85652 0.9375 11.637 1.6289 12.9497 2.85961C14.2625 4.09032 15 5.75952 15 7.5C15 9.24048 14.2625 10.9097 12.9497 12.1404C11.637 13.3711 9.85652 14.0625 8 14.0625ZM8 15C10.1217 15 12.1566 14.2098 13.6569 12.8033C15.1571 11.3968 16 9.48912 16 7.5C16 5.51088 15.1571 3.60322 13.6569 2.1967C12.1566 0.790176 10.1217 0 8 0C5.87827 0 3.84344 0.790176 2.34315 2.1967C0.842855 3.60322 0 5.51088 0 7.5C0 9.48912 0.842855 11.3968 2.34315 12.8033C3.84344 14.2098 5.87827 15 8 15Z"
                      fill="#92B9D5"
                    />
                    <path
                      d="M5.2551 5.42437C5.25373 5.45465 5.25898 5.48487 5.27053 5.51317C5.28208 5.54147 5.29968 5.56726 5.32225 5.58895C5.34482 5.61064 5.37189 5.62777 5.40179 5.63929C5.43168 5.65081 5.46378 5.65648 5.4961 5.65594H6.3211C6.4591 5.65594 6.5691 5.55 6.5871 5.42156C6.6771 4.80656 7.1271 4.35844 7.9291 4.35844C8.6151 4.35844 9.2431 4.68 9.2431 5.45344C9.2431 6.04875 8.8691 6.3225 8.2781 6.73875C7.6051 7.19719 7.0721 7.7325 7.1101 8.60156L7.1131 8.805C7.11415 8.86651 7.14095 8.92516 7.18772 8.96831C7.23449 9.01146 7.29748 9.03563 7.3631 9.03562H8.1741C8.2404 9.03562 8.30399 9.01093 8.35087 8.96698C8.39776 8.92302 8.4241 8.86341 8.4241 8.80125V8.70281C8.4241 8.02969 8.6971 7.83375 9.4341 7.30969C10.0431 6.87562 10.6781 6.39375 10.6781 5.38219C10.6781 3.96563 9.4021 3.28125 8.0051 3.28125C6.7381 3.28125 5.3501 3.83437 5.2551 5.42437ZM6.8121 10.8272C6.8121 11.3269 7.2371 11.6962 7.8221 11.6962C8.4311 11.6962 8.8501 11.3269 8.8501 10.8272C8.8501 10.3097 8.4301 9.94594 7.8211 9.94594C7.2371 9.94594 6.8121 10.3097 6.8121 10.8272Z"
                      fill="#92B9D5"
                    />
                  </svg>
                </h5>
                <h5 className="text-sec fw-light">400 €</h5>
              </div>
              <hr />
              <div className="d-flex px-2 justify-content-between align-items-center">
                <h5 className="fw-light">
                  Service fee{" "}
                  {/* <svg
                    width="16"
                    height="15"
                    viewBox="0 0 16 15"
                    fill="none"
                  >
                    <path
                      d="M8 14.0625C6.14348 14.0625 4.36301 13.3711 3.05025 12.1404C1.7375 10.9097 1 9.24048 1 7.5C1 5.75952 1.7375 4.09032 3.05025 2.85961C4.36301 1.6289 6.14348 0.9375 8 0.9375C9.85652 0.9375 11.637 1.6289 12.9497 2.85961C14.2625 4.09032 15 5.75952 15 7.5C15 9.24048 14.2625 10.9097 12.9497 12.1404C11.637 13.3711 9.85652 14.0625 8 14.0625ZM8 15C10.1217 15 12.1566 14.2098 13.6569 12.8033C15.1571 11.3968 16 9.48912 16 7.5C16 5.51088 15.1571 3.60322 13.6569 2.1967C12.1566 0.790176 10.1217 0 8 0C5.87827 0 3.84344 0.790176 2.34315 2.1967C0.842855 3.60322 0 5.51088 0 7.5C0 9.48912 0.842855 11.3968 2.34315 12.8033C3.84344 14.2098 5.87827 15 8 15Z"
                      fill="#92B9D5"
                    />
                    <path
                      d="M5.2551 5.42437C5.25373 5.45465 5.25898 5.48487 5.27053 5.51317C5.28208 5.54147 5.29968 5.56726 5.32225 5.58895C5.34482 5.61064 5.37189 5.62777 5.40179 5.63929C5.43168 5.65081 5.46378 5.65648 5.4961 5.65594H6.3211C6.4591 5.65594 6.5691 5.55 6.5871 5.42156C6.6771 4.80656 7.1271 4.35844 7.9291 4.35844C8.6151 4.35844 9.2431 4.68 9.2431 5.45344C9.2431 6.04875 8.8691 6.3225 8.2781 6.73875C7.6051 7.19719 7.0721 7.7325 7.1101 8.60156L7.1131 8.805C7.11415 8.86651 7.14095 8.92516 7.18772 8.96831C7.23449 9.01146 7.29748 9.03563 7.3631 9.03562H8.1741C8.2404 9.03562 8.30399 9.01093 8.35087 8.96698C8.39776 8.92302 8.4241 8.86341 8.4241 8.80125V8.70281C8.4241 8.02969 8.6971 7.83375 9.4341 7.30969C10.0431 6.87562 10.6781 6.39375 10.6781 5.38219C10.6781 3.96563 9.4021 3.28125 8.0051 3.28125C6.7381 3.28125 5.3501 3.83437 5.2551 5.42437ZM6.8121 10.8272C6.8121 11.3269 7.2371 11.6962 7.8221 11.6962C8.4311 11.6962 8.8501 11.3269 8.8501 10.8272C8.8501 10.3097 8.4301 9.94594 7.8211 9.94594C7.2371 9.94594 6.8121 10.3097 6.8121 10.8272Z"
                      fill="#92B9D5"
                    />
                  </svg> */}
                </h5>
                <h5 className="text-sec fw-light">400 €</h5>
              </div>
              <div className="d-flex px-2 justify-content-between align-items-center">
                <h5 className="fw-light">VAT 24%</h5>
                <h5 className="text-sec fw-light">400 €</h5>
              </div>

              <hr />
              <div className="d-flex px-2 justify-content-between align-items-center">
                <h5>Total</h5>
                <h5 className="text-sec">400 €</h5>
              </div>
              <hr />
              <Link
                to={`/finalizeBooking/${id}`}
                className="cs_btn text-white w-100 light-btn"
              >
                Book
              </Link>
              <span className="text-muted d-inline-block w-100 my-2 text-center mx-auto">
                This is a close estimate of the final booking price, payment
                will be asked at the end of the booking process
              </span>
              <Link
                to="/contact"
                className="cs_btn w-100 light-btn bg-light text-sec border"
              >
                Contact us if you need help for your trip
              </Link>
            </div>
            {/* <div className="yacht-detail-calendar-wrapper">
              <div className="only-preview-mode">
                {calendarPreview === 0 ? (
                  <div className="intradaycalender">
                    <Calendar disabled={true} date={formData.avail_days} />
                  </div>
                ) : (
                  <DateRangePicker
                    disabled={true}
                    ranges={dateState}
                    onChange={(item) => null}
                  />
                )}
              </div>
              <div className="yacht-detail-calendar-bottom d-flex">
                <button
                  onClick={() => setCalendarPreview(0)}
                  className={`${
                    calendarPreview === 0 ? "cal-actives" : ""
                  } yacht-detail-cal-btns`}
                >
                  Intraday
                </button>
                <button
                  onClick={() => setCalendarPreview(1)}
                  className={`${
                    calendarPreview === 1 ? "cal-actives" : ""
                  } yacht-detail-cal-btns`}
                >
                  OverNight
                </button>
              </div>
            </div>
            <div className="yacht-selected-date-wrapper d-flex">
              <div className="yacht-selected-dates-box d-flex">
                <span className="text-sec">14Oct</span>
                <div className="selected-dates-cap">
                  <span className="text-gr">09:00AM</span>
                  <span className="days-between-icon">
                    <ChevronRight className="text-sec" />
                  </span>
                  <span className="text-gr">10:00AM</span>
                </div>
              </div>
              <button className="book-now-yacht-btn">Book Now</button>
            </div>
            <div className="d-flex justify-content-center align-items-center">
              <button className="view-offer-yacht">
                View offers <img src={ViewOfferImg} alt="" />
              </button>
            </div> */}
          </div>
        </div>
        {/* reviews */}
        <div className="yacht-details-reviews-wrapper">
          <div className="yacht-detail-rating-sec py-3">
            <div className="d-flex justify-content-start align-items-center">
              <h5 className="font-weight-bold rev-had">
                Reviews ( <span className="text-gr">23</span> )
              </h5>
              <CustomRatings name="read-only" value={5} readOnly />
              &nbsp;
              <span className="font-weight-bold">4.8</span>
            </div>

            <div className="about-ratings px-0 ">
              <div className="about-ratings-card yacht-detail-about-rat">
                <p>Ratings Fields</p>
                <li>
                  Booking time and availability{" "}
                  <span>
                    <img src={StarImg} alt="" /> 4.9
                  </span>
                </li>
                <li>
                  Listings as described
                  <span>
                    {" "}
                    <img src={StarImg} alt="" /> 4.8
                  </span>
                </li>
                <li>
                  Would book again{" "}
                  <span>
                    <img src={StarImg} alt="" /> 4.7
                  </span>
                </li>
              </div>
              <div className="reviews-with-percents yacht-details-rev-with-perc">
                <ul>
                  <li>
                    <span className="name-of-stars">5 stars</span>
                    <span className="percnt-wrap">
                      <div className="perct-fill tw-h"></div>
                    </span>
                    <span className="num-of-ratings">(200)</span>
                  </li>
                  <li>
                    <span className="name-of-stars">4 stars</span>
                    <span className="percnt-wrap">
                      <div className="perct-fill twnt"></div>
                    </span>
                    <span className="num-of-ratings">(20)</span>
                  </li>
                  <li>
                    <span className="name-of-stars">3 stars</span>
                    <span className="percnt-wrap">
                      <div className="perct-fill fiv"></div>
                    </span>
                    <span className="num-of-ratings">(5)</span>
                  </li>
                  <li>
                    <span className="name-of-stars">2 stars</span>
                    <span className="percnt-wrap">
                      <div className="perct-fill thr"></div>
                    </span>
                    <span className="num-of-ratings">(3)</span>
                  </li>
                  <li>
                    <span className="name-of-stars">1 stars</span>
                    <span className="percnt-wrap">
                      <div className="perct-fill twoo"></div>
                    </span>
                    <span className="num-of-ratings">(2)</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          {/* all reviews  */}
          <div className="pt-4 mb-5 pb-3">
            {[0, 1, 2, 3, 4, 5].map((v, i) => {
              return (
                <div key={i} className="mb-4">
                  <div className="public-review-wrapper">
                    <div className="review-user-avatar">
                      <img src={defaultPersonImg} alt="" />
                    </div>
                    <div className="user-public-revs">
                      <div className="reves-uers-name pb-3">
                        <h6>Alex Jonson</h6>
                        <img src={reviewUSerFlag} alt="" />
                        &nbsp;<span className="text-muted">Greece</span>
                      </div>
                      <div className="revs-user-rats">
                        <img className="mx-1" src={StarImgBlue} alt="" />
                        <h6>5.0</h6>
                      </div>
                      <p className="text-muted">
                        Really fast service. Amazing work . Definitely will be
                        using services again. Thank you.
                      </p>
                    </div>
                  </div>
                  <div className="text-right w-100 text-muted px-3">
                    00-00-2021
                  </div>
                </div>
              );
            })}

            <div className="reviews-loadmore-btn w-100 d-flex justify-content-center align-items-center">
              <button>+ Load More</button>
            </div>
          </div>
          <div className="cs-hr-for-det mb-3"></div>
        </div>
        {/* related yacht */}
        <div className="">
          <h5>Similar yachts that you may also like</h5>
          {/*  Favorite Slider */}
          <div className="col-12 mt-4 mb-5">
            <Swiper
              className="pb-5"
              grabCursor
              spaceBetween={15}
              slidesPerView={4}
              pagination
              speed={500}
              // loop
              breakpoints={{
                // when window width is >= 640px
                100: {
                  slidesPerView: 1,
                },
                390: {
                  slidesPerView: 2,
                },
                550: {
                  slidesPerView: 3,
                },
                992: {
                  slidesPerView: 4,
                },
              }}
            >
              {[0, 1, 2, 3, 4, 5, 6, 8, 9, 10, 11, 12].map((cardItem, i) => {
                return (
                  <SwiperSlide className={`px-2`} key={i}>
                    <SliderCard
                      user={props.current_user}
                      openLoginModel={setLogin}
                      linkEnabled={true}
                      link={"/yachtDetail/" + i}
                      data={{
                        id: i,
                        img: defaultCardImg,
                        title: "Motorboat Azimut 62",
                        location: "Crete . Greece",
                        price: "1260",
                      }}
                    />
                  </SwiperSlide>
                );
              })}
            </Swiper>
          </div>
        </div>
      </div>
      {/* APA model popUP */}
      <CustomModal openPopup={apaPolicyModal} setOpenPopup={setApaPolicyModal}>
        <div className="bg-white more-filter-modal  rounded p-md-4 p-2">
          <div className="d-flex">
            <div
              className="filter-model-close-btn ms-auto"
              onClick={() => setApaPolicyModal(false)}
            >
              <Close />
            </div>
          </div>
          <div className="with-left-border more-filter-pop-body">
            <h4 className="text-pr "> Advance Provisioning Allowance (APA)</h4>
            <p className="mt-3">
              <span className="text-pr">
                The Advance Provisioning Allowance (APA){" "}
              </span>{" "}
              is designed to cover the operating expenses of a charter such as,
              fuel (for the yacht, her tenders and motorized water toys), food,
              drinks, land services, electronic communications, canal fees,
              harbor dues, local taxes and marina fees in private marinas.
              Depending on the number of guests, type of yacht and duration of
              charter, the APA will vary. The yacht will be fully fueled and
              provisioned (if you have filled the provision list prior to
              charter) when the guests step on board. Whilst an up-to-date
              summary of accounts can be requested at any time during your
              charter, a full set of accounts will normally be submitted by your
              captain at the end of the charter. If, during the charter, the
              expenditure exceeds the sum already paid, additional cash funds
              will be required at once, on the other side if there is a leftover
              balance from the money paid by the client, the captain will return
              the difference in cash to the client prior to disembarkation. All
              outstanding bills should be settled in cash before final
              disembarkation.
            </p>
          </div>
        </div>
      </CustomModal>
      {/* login model popUP */}
      <CustomModal openPopup={loginOpen} setOpenPopup={setLogin}>
        <SiginInPopup closeModel={setLogin} />
      </CustomModal>

      <Link
        to="/contact"
        className="light-btn text-white my-2 w-max d-md-none d-inline p-2 rounded-pill px-3  mobile_fixed_btns left"
      >
        Contact us
      </Link>
      <Link
        to={`/finalizeBooking/${id}`}
        className="dark-btn text-white my-2 w-max d-md-none d-inline p-2 rounded-pill px-3  right mobile_fixed_btns"
      >
        Request Boat
      </Link>

      {/* Gallery Modal */}
      {galleryModal && (
        <div className="yacht_detail_gallery_modal_main d-flex flex-column">
          <div className="row yacht_detail_gallery_modal_slider_header justify-content-between align-items-center">
            <img src={logo} alt="" className="header-logo" />
            <div
              className="filter-model-close-btn bg-white text-dark ms-auto"
              onClick={() => handleGalleryModal("close")}
            >
              <Close />
            </div>
          </div>
          <div className="yacht_detail_gallery_modal_slider d-flex">
            <Swiper
              pagination={{
                clickable: true,
              }}
              grabCursor
              spaceBetween={35}
              slidesPerView={1}
              navigation
              speed={500}
              loop
              onBeforeInit={(swiper) => {
                swiper.params.pagination.el = ".yacht-slider-paging";
                swiper.params.pagination.bulletActiveClass =
                  "active-paging-item";
                swiper.params.pagination.bulletClass =
                  "custom-paging-item-yacht-slider";
                swiper.params.pagination.clickable = true;
                swiper.params.pagination.renderBullet = (index, className) => {
                  return `<span  class="yacht-detail-bullets yacht-detail-modal-paging-box ${className}">
                    <img class="detail-bullet-img" src=${images[index]} alt="" />
                  </span>`;
                };
              }}
            >
              {[0, 1, 2, 3, 4, 5, 6, 8, 9, 10, 11, 12].map((v, i) => {
                return (
                  <SwiperSlide
                    className={`px-2 d-flex justify-content-center align-items-center text-center`}
                    key={i}
                  >
                    <img
                      src={sliderImg}
                      alt=""
                      className="yacht_detail_gallery_modal_img"
                    />
                  </SwiperSlide>
                );
              })}
            </Swiper>
          </div>
          <div className="cs_container">
            <div className="yacht-slider-paging yacht-detail-modal-paging"></div>
          </div>
        </div>
      )}
    </div>
  );
};

// Redux store config
const mapStateToProps = (store) => ({
  current_user: store.current_user,
});

export default connect(mapStateToProps, null)(YachtDetail);
